import React, { useEffect } from 'react'
import { Container } from '@orbital/games-frontend-library'
import { cyberColors } from '../../lib/colors'
import PageHeader from '../header/Header'
import ProvablySeedPair from './elements/ProvablySeedPairs'
import UseProvablySeeds from './helperFunctions/UseProvablySeeds'
import { Main, Title } from './ProvablyStyle'
import SeedForm from './elements/ProvablySeedForm'
import Button from '../../components/elements/button/Button'

export default function ProvablyFair({
  handleAbove,
  seeds,
  handleNotification,
  seedRequest,
  newSeedRequest,
  autoPlayIsOn,
  audio,
}: any) {
  const { CurrentSeedPair, PreviousSeedPair } = UseProvablySeeds(seeds)

  useEffect(() => {
    seedRequest()
  }, [])

  const VfCheck = () => {
    window.open('https://codepen.io/orbitalgaming/pen/GReKKxW', '_blank')
  }
  return (
    <Container backgroundColor={cyberColors.black} padding={'21px 30px 10px;'}>
      <PageHeader
        title={'provably fair'}
        func={() => handleAbove(false)}
        audio={audio}
      />
      <Main>
        <ProvablySeedPair
          pf={CurrentSeedPair}
          handleNotification={handleNotification}
        />
        <SeedForm sendSeed={newSeedRequest} autoPlayIsOn={autoPlayIsOn} />
        <Title>previous seed pair</Title>
        <ProvablySeedPair
          pf={PreviousSeedPair}
          handleNotification={handleNotification}
        />
        <Button
          isDisabled={PreviousSeedPair[0].content == '-'}
          background={cyberColors.blueGradient}
          width={'100%'}
          size={'26px'}
          margin={'5px 0 0'}
          func={() => VfCheck()}
        >
          <p>Verify</p>
        </Button>
      </Main>
    </Container>
  )
}
